const SUPABASE_PUBLIC_STORAGE_ORIGIN =
  "https://zqqvmfeqhbboxlurgkme.supabase.co";

const PUBLIC_OBJECT_PATH = "/storage/v1/object/public";

export function supabasePublicObjectUrl(bucket: string, path: string): string {
  const cleanBucket = bucket.replace(/^\/+|\/+$/g, "");
  const cleanPath = path.replace(/^\/+/g, "");
  return `${SUPABASE_PUBLIC_STORAGE_ORIGIN}${PUBLIC_OBJECT_PATH}/${encodePathSegment(
    cleanBucket,
  )}/${encodeObjectPath(cleanPath)}`;
}

export function appLevelAssetUrl(path: string): string {
  return supabasePublicObjectUrl("app-level", path);
}

function encodeObjectPath(path: string): string {
  return path.split("/").filter(Boolean).map(encodePathSegment).join("/");
}

function encodePathSegment(segment: string): string {
  return encodeURIComponent(segment);
}
